<template>
  <div
    layout="column"
    class="white"
    :class="[($vuetify.breakpoint. smAndDown && displaySidenav) ? 'fixed' : '']"
  >
    <div
      layout="row"
      layout-align="start center"
    >
      <img
        v-if="connected || $vuetify.breakpoint.smAndDown || $route.name == 'legal-notice'"
        @click="displaySidenav = false; connected ? $router.push({name: 'my-wall'}) : $router.push({name: 'login'})"
        src="@/assets/nev-logo.png"
        class="ne-logo clickable"
      />
      <div
        v-if="connected"
        layout="column"
        layout-align="start start"
        class="hidden-sm-and-down"
        style="margin-left: 50px"
      >
        <img
          src="@/assets/GOUV_MENJE.png"
          height="70"
          class="mb-1"
        />
      </div>
      <span flex></span>
      <div
        v-if="connected"
        class="search-bar hidden-sm-and-down"
      >
        <v-menu
          v-model="searching"
          offset-y
          full-width
          max-width="390"
          max-height="300"
          class="mr-2"
        >
          <v-text-field
            v-model="search"
            :placeholder="$t('_.search_bar')"
            :hide-no-data="(!search || search.length < 3) ? true : false"
            hide-details
            solo
            return-object
            single-line
            :loading="loading"
            flat
            height="20"
            prepend-inner-icon="mdi-magnify"
            slot="activator"
          ></v-text-field>
          <v-list
            v-if="items && items.length"
            class="search-list"
          >
            <v-list-tile
              v-for="(item, index) in items"
              :key="index"
              @click="handleSelect(item)"
              class="search-item"
            >
              <div
                v-if="item.type == 'Message'"
                layout="row"
                layout-align="start center"
                style="color: black"
                class="body-1"
              >
                <v-avatar
                  class="ml-1"
                  style="margin-right: 12px"
                  size="28"
                >
                  <v-icon
                    color="white"
                    class="circle-container secondary"
                    size="14"
                  >mdi-{{typeIcon(item.object.type)}}</v-icon>
                </v-avatar>
                <div layout="column">
                  <div layout="row">
                    <b v-if="isCurrent(item.object)">{{$t('_.yourself')}}</b>
                    <b v-else-if="isMEN(item.object)">{{$t('_.the')}} MEN</b>
                    <b v-else-if="isDeleted(item.object)">{{$t('users.inactive')}}</b>
                    <b v-else>{{fullname(item.object)}}</b>
                    , {{$t('_.on')}} {{createdAt(item.object)}}
                  </div>
                  <p
                    class="mb-0"
                    style="max-width: 300px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                  >{{item.object.body}}</p>
                </div>
              </div>

              <div
                v-else-if="item.type == 'User'"
                layout="row"
                layout-align="start center"
                class="body-1"
                style="color: black"
              >
                <avatar
                  :fullname="item.object.firstname + ' ' + item.object.lastname"
                  :image="getImageData(item.object.id)"
                  class="mr-2"
                  size="18"
                ></avatar>
                <div layout="column">
                  <b>{{item.object.firstname}} {{item.object.lastname}}</b>
                  {{item.object.school.name}}
                </div>
              </div>
            </v-list-tile>
          </v-list>
          <div
            v-else-if="!loading && search && search.length > 2"
            class="text-xs-center py-2"
          >
            <em>{{$t('_.no_result')}}</em>
          </div>
        </v-menu>
      </div>
      <v-btn
        :key="l"
        v-for="l in $store.state.locales"
        small
        :class="['hidden-sm-and-down', l, (currentLang == l) ? 'active-lang' : 'unactive-lang']"
        style="min-width: 0px;"
        @click.prevent="setLang(l)"
        depressed
        light
        color="transparent"
        flat
      >
        <span style="color: black">{{l}}</span>
      </v-btn>
      <template v-if="connected">
        <avatar
          size="40"
          :fullname="fullName"
          :image="getImageData(userId)"
          class="ml-3 mr-1 hidden-sm-and-down"
        ></avatar>
        <v-menu
          v-model="showMenu"
          offset-y
          offset-x
          bottom
        >
          <v-btn
            slot="activator"
            class="mx-0 mr-2 hidden-sm-and-down"
            icon
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              v-if="!isAdmin"
              @click="$router.push({name: 'representatives-show', params: {id: userId}})"
            >
              <v-list-tile-action
                style="min-width: 0;"
                class="pr-3"
              >
                <v-icon>mdi-account-circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{$t('nav.profile')}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="logout()">
              <v-list-tile-action
                style="min-width: 0;"
                class="pr-3"
              >
                <v-icon>mdi-logout</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{$t('nav.logout')}}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
      <v-btn
        class="mx-0 mr-2 hidden-md-and-up"
        icon
        @click="displaySidenav = !displaySidenav"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </div>
    <div
      v-if="$vuetify.breakpoint.smAndDown && displaySidenav"
      class="mobile-sidenav"
    >
      <v-list style="background: transparent;">
        <v-list-group
          v-if="connected"
          no-action
          prepend-icon="mdi-message"
        >
          <v-list-tile
            slot="activator"
            @click.prevent="() => {}"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{$t('nav.messages')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click.prevent="goWall(); displaySidenav = false;">
            <v-list-tile-content>
              <v-list-tile-title :class="{'black--text' : $route.name.indexOf('my-wall') != 0}">
                <div
                  layout="row"
                  layout-align="start center"
                >
                  {{$t('nav.wall')}}
                  <v-badge
                    v-if="nbWall"
                    color="red"
                    overlap
                    class="sidenav-badge"
                  >
                    <span slot="badge">{{nbWall}}</span>
                  </v-badge>
                </div>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click.prevent="goMessages(); displaySidenav = false;">
            <v-list-tile-content>
              <v-list-tile-title :class="{'black--text' : $route.name.indexOf('my-messages') != 0}">
                <div
                  layout="row"
                  layout-align="start center"
                >
                  {{$t('nav.privates')}}
                  <v-badge
                    v-if="nbPrivate"
                    color="red"
                    overlap
                    class="sidenav-badge"
                  >
                    <span slot="badge">{{nbPrivate}}</span>
                  </v-badge>
                </div>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-if="isAdmin"
            @click.prevent="$router.push({name: 'abusive-messages-index'}); displaySidenav = false;"
          >
            <v-list-tile-content>
              <v-list-tile-title :class="{'black--text' : $route.name.indexOf('abusive-messages') != 0}">
                {{$t('nav.abusive')}}
                <v-badge
                  v-if="nbReports"
                  color="red"
                  overlap
                  class="sidenav-badge"
                >
                  <span slot="badge">{{nbReports}}</span>
                </v-badge>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <!-- Cercles group -->
        <v-list-group
          v-if="connected"
          no-action
          prepend-icon="mdi-set-none"
        >
          <v-list-tile
            @click.prevent="() => {}"
            slot="activator"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{$t('nav.circles')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- All the circles -->
          <v-list-tile
            @click.prevent="$router.push({name: 'circles-index'}); displaySidenav = false;"
            :class="{'active-tab' : $route.name.indexOf('circles-index') == 0}"
          >
            <v-list-tile-content>
              <v-list-tile-title class="black--text subheading">{{$t('nav.the_circles')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- My Circle -->
          <v-list-tile @click.prevent="goCircle(); displaySidenav = false;">
            <v-list-tile-content>
              <v-list-tile-title :class="{'black--text' : $route.name.indexOf('my-circle') != 0}">
                <div
                  layout="row"
                  layout-align="start center"
                >
                  {{$t('nav.circle')}}
                  <v-badge
                    v-if="nbCircle"
                    color="red"
                    overlap
                    class="sidenav-badge"
                  >
                    <span slot="badge">{{nbCircle}}</span>
                  </v-badge>
                </div>
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>star</v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <!-- Subscribed circles -->
          <v-list-tile
            v-for="c in $store.state.circles"
            :key="c.id"
            @click.prevent="$router.push({name: 'circles-show', params: {id: c.id}}); displaySidenav = false;"
            :class="{'active-tab' : (($route.name.indexOf('circles-show') == 0) && ($route.params.id == c.id))}"
          >
            <v-list-tile-content>
              <v-list-tile-title class="black--text subheading">{{c.name}}
                <v-badge
                  v-if="c.nb_unread"
                  color="red"
                  overlap
                  class="sidenav-badge"
                >
                  <span slot="badge">{{c.nb_unread}}</span>
                </v-badge>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-group
          v-if="connected"
          no-action
          prepend-icon="mdi-toolbox"
        >
          <v-list-tile
            @click.prevent="() => {}"
            slot="activator"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{$t('nav.tools')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-if="isAdmin"
            @click.prevent="$router.push({name: 'admin-index'}); displaySidenav = false;"
          >
            <v-list-tile-content>
              <v-list-tile-title :class="{'black--text' : $route.name.indexOf('admin-settings') != 0}">{{$t('nav.settings')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="isAdmin"
            @click.prevent="$router.push({name: 'admin-schools-index'}); displaySidenav = false;"
          >
            <v-list-tile-content>
              <v-list-tile-title :class="{'black--text' : $route.name.indexOf('admin-schools-index') != 0}">{{$t('nav.schools')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click.prevent="$router.push({name: 'representatives-index'}); displaySidenav = false;">
            <v-list-tile-content>
              <v-list-tile-title :class="{'black--text' : $route.name.indexOf('representatives-') != 0}">{{$t('nav.book')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click.prevent="$router.push({name: 'documents-index'}); displaySidenav = false;">
            <v-list-tile-content>
              <v-list-tile-title :class="{'black--text' : $route.name.indexOf('documents-') != 0}">{{$t('nav.docs')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="isAdmin || isNational"
            @click.prevent="$router.push({name: 'surveys-index'}); displaySidenav = false;"
          >
            <v-list-tile-content>
              <v-list-tile-title :class="{'black--text' : $route.name.indexOf('surveys-') != 0}">{{$t('nav.surveys')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="isAdmin"
            @click.prevent="$router.push({name: 'admin-stats-connections'}); displaySidenav = false;"
          >
            <v-list-tile-content>
              <v-list-tile-title :class="{'black--text' : $route.name.indexOf('admin-stats-') != 0}">{{$t('nav.stats')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-group
          no-action
          prepend-icon="mdi-earth"
        >
          <v-list-tile
            slot="activator"
            @click.prevent="() => {}"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{$t('nav.lang')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-for="l in $store.state.locales"
            :key="'loc_'+l"
            @click.prevent="setLang(l); displaySidenav = false"
          >
            <v-list-tile-content>
              <v-list-tile-title
                :class="{'black--text' : currentLang != l}"
                class="text-uppercase"
              >{{l}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-tile
          v-if="connected && !isAdmin"
          @click.prevent="displaySidenav = false; $router.push({name: 'representatives-show', params: {id: userId}})"
        >
          <v-list-tile-action style="min-width: 56px">
            <v-icon>mdi-account-circle</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title :class="{'black--text' : ($route.name != 'representatives-show' || $route.params.id !=  userId)}">{{$t('nav.profile')}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="connected"
          @click.prevent="displaySidenav = false; logout()"
        >
          <v-list-tile-action style="min-width: 56px">
            <v-icon>mdi-logout</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="black--text">{{$t('nav.logout')}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </div>
    <v-dialog
      v-if="messageDialog"
      v-model="messageDialog"
      max-width="900"
      z-index="202"
      :fullscreen="$vuetify.breakpoint. smAndDown"
    >
      <message
        :message="editingMessage"
        class="full-width"
        style="background: white"
        @edit="editMessage(editingMessage)"
        @removed="onDelete()"
        @deleted="onDelete()"
      ></message>
    </v-dialog>
    <v-dialog
      v-if="editDialog"
      v-model="editDialog"
      max-width="900"
      z-index="300"
      content-class="edit-dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <div
        layout="column"
        layout-align="start start"
        style="background: white"
        class="full-width px2-pc py3-pc pa1-mobile"
      >
        <message-form
          v-if="isEditingMessage"
          @cancel="onMessageCancel"
          @save="save"
          ref="messageForm"
          v-model="editingMessage"
          :loading="loading"
        ></message-form>
        <message-form
          v-if="isEditingEvent"
          is-event
          @cancel="onEventCancel"
          @save="save"
          ref="messageForm"
          v-model="editingMessage"
          :loading="loading"
        ></message-form>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import Avatar from "@/components/shared/Avatar"
import Auth from "@/plugins/auth"
import ImageMixin from "@/mixins/image"
import EventBus from "@/plugins/eventbus"
import Consts from "@/consts"
import Useful from "@/api/useful"
import I18nMixin from "@/mixins/i18n"
import Message from "@/components/shared/Message"
import MessageForm from "@/components/shared/MessageForm"
import moment from "moment"
import FormDataMixin from "@/mixins/formdata"
import Messages from "@/api/messages"
import Conversations from "@/api/conversations"

export default {
  components: { Avatar, Message, MessageForm },
  mixins: [ImageMixin, I18nMixin, FormDataMixin],
  data () {
    return {
      isAdmin: false,
      isNational: false,
      isLocal: false,
      isSectoral: false,
      currentLang: null,
      imgs: {},
      imgsLoad: {},
      displaySidenav: false,
      connected: false,
      showMenu: false,
      fullName: "",
      userId: null,
      search: "",
      search2: "",
      items: [],
      loading: false,
      messageDialog: false,
      schools: [],
      rds: [],
      regions: [],
      isEditingMessage: false,
      isEditingEvent: false,
      editingMessage: {
        type: Consts.CIRCLE,
        body: "",
        levels_ids: [],
        sectors_ids: [],
        schools_ids: [],
        regional_directorates_ids: [],
        regions_ids: [],
        cities_ids: [],
        circles_ids: [],
        date_start: null,
        creator: {},
      },
      editDialog: false,
      nbCircle: 0,
      nbWall: 0,
      nbReports: 0,
      nbPrivate: 0,
      circleLoaded: false,
      wallLoaded: false,
      searching: false,
    }
  },
  mounted () {
    if (!this.hasFoLangs) {
      this.$store.commit("LOAD_LANGS")
    }

    if (Auth.user && Auth.user.lang_id) {
      this.$store.commit("SET_LANG", Auth.user.lang_id)
      this.$i18n.locale = Auth.user.lang_id
      this.$vuetify.lang.current = Auth.user.lang_id
      this.currentLang = Auth.user.lang_id
    } else {
      this.$store.commit("SET_LANG", "fr")
      this.$i18n.locale = "fr"
      this.$vuetify.lang.current = "fr"
      this.currentLang = "fr"
    }

    this.loadUser()
    this.loadProfilePicture()

    if (Auth.user && this.$vuetify.breakpoint.smAndDown) {
      this.fetchNbWall()
      this.fetchNbCircle()
      this.fetchNbPrivate()
      if (this.isAdmin) {
        this.fetchNbReports()
      }
    }

    this.interval = setInterval(
      function () {
        if (Auth.user) {
          if (this.$vuetify.breakpoint.smAndDown) {
            this.fetchNbWall()
            this.fetchNbCircle()
            this.fetchNbReports()
          }

          this.$store.commit("LOAD_CIRCLES", true)
        }
      }.bind(this),
      60000
    ) //Refresh le nb de messages non lus toutes les minutes

    this.intervalPrivates = setInterval(
      function () {
        if (Auth.user) {
          if (this.$vuetify.breakpoint.smAndDown) {
            this.fetchNbPrivate()
          }
        }
      }.bind(this),
      10000
    )

    EventBus.$on("avatar-changed", this.loadProfilePicture)
    EventBus.$on("user-changed", this.loadUser)
    EventBus.$on("lang-changed", this.updateLang)
    EventBus.$on("privates-update", this.fetchNbPrivate)
  },
  destroyed () {
    EventBus.$off("avatar-changed")
    EventBus.$off("user-changed")
    EventBus.$off("lang-changed")
    EventBus.$off("privates-update")
    clearInterval(this.interval)
    clearInterval(this.intervalPrivates)
  },
  watch: {
    hasFoLangs (val, oldVal) {
      if (val && !oldVal) {
        if (Auth.user && Auth.user.lang_id) {
          this.$store.commit("SET_LANG", Auth.user.lang_id)
          this.$i18n.locale = Auth.user.lang_id
          this.$vuetify.lang.current = Auth.user.lang_id
          this.currentLang = Auth.user.lang_id
        } else {
          this.$store.commit("SET_LANG", "fr")
          this.$i18n.locale = "fr"
          this.$vuetify.lang.current = "fr"
          this.currentLang = "fr"
        }
      }
    },
    search (val) {
      val && val !== this.querySearchAsync(val)
    },
  },
  methods: {
    onMessageCancel () {
      this.isEditingMessage = false
      this.resetMessage()
    },
    onEventCancel () {
      this.isEditingEvent = false
      this.resetMessage()
    },
    setLang (e) {
      this.currentLang = e
      this.$store.commit("SET_LANG", e)
      this.$i18n.locale = e
      this.$vuetify.lang.current = e
    },
    updateLang () {
      this.currentLang = this.$store.state.locale
    },
    loadProfilePicture () {
      this.imgs = {}
      this.imgsLoad = {}
      if (Auth.user && Auth.user.avatar_id) {
        this.getImage("/assets/users/" + Auth.user.id, Auth.user.id)
      }
    },
    logout () {
      Auth.logout()
      this.$router.push("/login")
    },
    loadUser () {
      if (
        Auth.user &&
        (Auth.user.is_admin || Auth.user.level == Consts.MINISTRY)
      ) {
        this.isAdmin = true
      } else {
        this.isAdmin = false
      }

      if (Auth.user && Auth.user.level == Consts.NATIONAL) {
        this.isNational = true
      } else {
        this.isNational = false
      }

      if (Auth.user && Auth.user.level == Consts.SECTORAL) {
        this.isSectoral = true
      } else {
        this.isSectoral = false
      }

      if (Auth.user && Auth.user.level == Consts.LOCAL) {
        this.isLocal = true
      } else {
        this.isLocal = false
      }

      if (Auth.user) {
        this.connected = true
        this.fullName = Auth.user.firstname + " " + Auth.user.lastname
        this.userId = Auth.user.id
        this.$store.commit("LOAD_CITIES")
        this.$store.commit("LOAD_CIRCLES")
      } else {
        this.connected = false
        this.fullName = ""
        this.userId = null
      }
    },
    fetchNbCircle () {
      Messages.getUnread(1).then((res) => {
        if (
          this.circleLoaded &&
          res.data &&
          res.data != 0 &&
          res.data != this.nbCircle
        ) {
          EventBus.$emit("new-circle", res.data)
        }
        this.nbCircle = res.data
        this.circleLoaded = true
      })
    },
    fetchNbWall () {
      Messages.getUnread(0).then((res) => {
        if (
          this.wallLoaded &&
          res.data &&
          res.data != 0 &&
          res.data != this.nbWall
        ) {
          EventBus.$emit("new-wall", res.data)
        }
        this.nbWall = res.data
        this.wallLoaded = true
      })
    },
    fetchNbReports () {
      if (Auth.user.is_admin || Auth.user.level == Consts.MINISTRY) {
        Messages.nbReports().then((res) => {
          this.nbReports = res.data
        })
      }
    },
    fetchNbPrivate () {
      Conversations.getUnread().then((res) => {
        if (res.data && res.data != 0 && res.data != this.nbPrivate) {
          EventBus.$emit("new-private", res.data)
        }

        this.nbPrivate = res.data
      })
    },
    goWall () {
      if (this.$route.name != "my-wall") {
        this.nbWall = 0
      }
      this.$router.push({ name: "my-wall" })
    },
    goCircle () {
      if (this.$route.name != "my-circle") {
        this.nbCircle = 0
      }
      this.$router.push({ name: "my-circle" })
    },
    goMessages () {
      this.$router.push({ name: "my-messages" })
    },
    querySearchAsync (queryString) {
      if (!queryString || queryString.length < 3) {
        return
      }

      this.loading = true
      this.searching = true

      // cancel pending call
      clearTimeout(this._timerId)

      // delay new call 350ms
      this._timerId = setTimeout(() => {
        Useful.search(queryString).then((res) => {
          const sr = res.data

          let out = []

          if (sr.messages) {
            for (let i in sr.messages) {
              out.push({
                type: "Message",
                object: sr.messages[i],
              })
            }
          }

          if (sr.users) {
            for (let i in sr.users) {
              out.push({
                type: "User",
                object: sr.users[i],
              })

              if (sr.users[i].avatar_id) {
                this.getImage(
                  "/assets/users/" + sr.users[i].id,
                  sr.users[i].id
                )
              }
            }
          }

          this.items = out
          this.loading = false
          this.search2 = queryString
        })
      }, 350)
    },
    handleSelect (val) {
      if (val) {
        if (val.type == "Message") {
          this.editingMessage = Object.assign(
            {},
            JSON.parse(JSON.stringify(val.object))
          )
          this.messageDialog = true
        } else {
          this.$router.push({
            name: "representatives-show",
            params: { id: val.object.id },
          })
        }
      }
    },
    typeIcon (t) {
      switch (t) {
        case Consts.EVENT:
          return "calendar"
        case Consts.SURVEY:
          return "clipboard-text"
        case Consts.CIRCLE:
          return "set-none"
        case Consts.PLATFORM:
          return "send"
        case Consts.TOPDOWN:
          return "arrow-expand-down"
        case Consts.BOTTOMUP:
          return "arrow-expand-up"
        case Consts.HORIZONTAL:
          return "arrow-expand-horizontal"
      }
    },
    isMEN (m) {
      if (m.origin) {
        if (
          m.origin.creator.is_admin ||
          m.origin.creator.level == Consts.MINISTRY
        ) {
          return true
        }
      } else {
        if (m.creator.is_admin || m.creator.level == Consts.MINISTRY) {
          return true
        }
      }
      return false
    },
    isCurrent (m) {
      if (m.origin) {
        if (Auth.user.id == m.origin.creator_id) {
          return true
        }
      } else {
        if (Auth.user.id == m.creator_id) {
          return true
        }
      }
      return false
    },
    isDeleted (m) {
      if (m.origin) {
        if (m.origin.creator.is_deleted) {
          return true
        }
      } else {
        if (m.creator.is_deleted) {
          return true
        }
      }
      return false
    },
    fullname (m) {
      if (m.origin) {
        return m.origin.creator.firstname + " " + m.origin.creator.lastname
      } else {
        return m.creator.firstname + " " + m.creator.lastname
      }
    },
    createdAt (m) {
      if (m.origin) {
        return (
          this.formatDateI18n(m.origin.created_at) +
          " " +
          this.$t("_.at") +
          " " +
          this.formatHour(m.origin.created_at)
        )
      } else {
        return (
          this.formatDateI18n(m.created_at) +
          " " +
          this.$t("_.at") +
          " " +
          this.formatHour(m.created_at)
        )
      }
    },
    resetMessage () {
      this.$refs.messageForm.$refs.form.reset()
      this.defaultMessage()
    },
    defaultMessage () {
      this.editingMessage = Object.assign(
        {},
        {
          type: Consts.CIRCLE,
          body: "",
          levels_ids: [],
          sectors_ids: [],
          schools_ids: [],
          regional_directorates_ids: [],
          regions_ids: [],
          cities_ids: [],
          circles_ids: [],
          date_start: null,
        }
      )
    },
    save (data) {
      if (!this.$refs.messageForm.$refs.form.validate()) {
        return
      }

      if (
        this.isEditingEvent &&
        (!this.editingMessage.date_start ||
          !moment(this.editingMessage.date_start).isValid())
      ) {
        this.$snotify.error(this.$t("messages.date_err"))
        return
      }

      this.loading = true

      // Convert the data to FormData for proper file upload
      let formData = new FormData()
      let o = Object.assign(
        {},
        this.editingMessage,
        { deleted_medias: data.deletedMedias },
        { deleted_docs: data.deletedDocs }
      )
      this._convertObjectToFormData(formData, o)

      if (data.banner && data.banner != {} && data.banner instanceof Blob) {
        formData.append("banner", data.banner, data.banner.name)
      }

      for (let i = 0; i < data.medias.length; i++) {
        if (!data.medias[i].id) {
          formData.append(
            "medias[" + i + "]",
            data.medias[i],
            data.medias[i].name
          )
        }
      }

      for (let i = 0; i < data.documents.length; i++) {
        if (!data.documents[i].id) {
          formData.append(
            "documents[" + i + "]",
            data.documents[i],
            data.documents[i].name
          )
        }
      }

      if (!this.editingMessage.id) {
        Messages.create(formData).then(
          () => {
            this.resetMessage()
            this.loading = false
            this.isEditingMessage = false
            this.isEditingEvent = false
            this.editDialog = false
            this.messageDialog = false
            this.search = ""
            this.search2 = ""
            this.items = []
            this.$snotify.success(this.$t("messages.created"))
          },
          () => {
            this.loading = false
          }
        )
      } else {
        Messages.updateAsForm(this.editingMessage.id, formData).then(
          () => {
            this.resetMessage()
            this.loading = false
            this.isEditingMessage = false
            this.isEditingEvent = false
            this.editDialog = false
            this.messageDialog = false
            this.search = ""
            this.search2 = ""
            this.items = []
            this.$snotify.success(this.$t("messages.edited"))
          },
          () => {
            this.loading = false
          }
        )
      }
    },
    onDelete () {
      this.editingMessage = {}
      this.messageDialog = false
      this.search = ""
      this.search2 = ""
      this.items = []
    },
    editMessage (m) {
      if (m.type == Consts.SURVEY) {
        this.$router.push({
          name: "surveys-edit",
          params: { id: m.survey_id },
        })
      } else if (m.type == Consts.EVENT) {
        this.defaultMessage()
        this.editingMessage = JSON.parse(JSON.stringify(m))
        this.isEditingEvent = true
        this.editDialog = true
      } else {
        this.defaultMessage()
        this.editingMessage = JSON.parse(JSON.stringify(m))

        this.isEditingMessage = true
        this.editDialog = true

        this.editingMessage.levels_ids = []
        this.editingMessage.sectors_ids = []
        this.editingMessage.regional_directorates_ids = []
        this.editingMessage.regions_ids = []
        this.editingMessage.cities_ids = []
        this.editingMessage.schools_ids = []
        this.editingMessage.circles_ids = []

        for (
          let i = 0;
          i < this.editingMessage.regional_directorates.length;
          i++
        ) {
          this.editingMessage.regional_directorates_ids.push(
            this.editingMessage.regional_directorates[i].id
          )
        }

        for (let i = 0; i < this.editingMessage.regions.length; i++) {
          this.editingMessage.regions_ids.push(
            this.editingMessage.regions[i].id
          )
        }

        for (let i = 0; i < this.editingMessage.schools.length; i++) {
          this.editingMessage.schools_ids.push(
            this.editingMessage.schools[i].id
          )
        }

        for (let i = 0; i < this.editingMessage.levels.length; i++) {
          this.editingMessage.levels_ids.push(
            this.editingMessage.levels[i].level
          )
        }

        for (let i = 0; i < this.editingMessage.sectors.length; i++) {
          this.editingMessage.sectors_ids.push(
            this.editingMessage.sectors[i].sector
          )
        }

        for (let i = 0; i < this.editingMessage.cities.length; i++) {
          this.editingMessage.cities_ids.push(this.editingMessage.cities[i].id)
        }
      }
    }
  },
  computed: {
    hasFoLangs () {
      if (!this.$store.state.locales || !this.$store.state.locales.length) {
        return false
      } else {
        return true
      }
    },
  },
};
</script>

<style scoped>
.active-lang {
  border-bottom: 4px solid #589c8f;
}

.mobile-sidenav {
  height: 100%;
  width: 100%;
  z-index: 20;
  position: fixed;
  top: 50px;
  background: white;

  transition: all 0.25s;
  -webkit-transition: all 0.25s;
}

.logo {
  width: 48px;
}

.search-bar {
  width: 400px;
}

.search-bar .v-input {
  border: 1px solid #dddddd;
  border-radius: 4px;
}

.toolbar-container {
  position: relative;
}

.ne-logo {
  height: 110px;
  margin-left: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
}

@media screen and (max-width: 960px) {
  .ne-logo {
    height: 50px;
  }
}
</style>
<style>
.sidenav-badge > .v-badge__badge {
  top: 0;
  right: 0;
  position: unset;
  margin-left: 5px;
}
.sidenav-badge {
  position: unset;
}
.search-menu > .v-select-list > .v-list > div:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.05);
}
.search-menu > .v-select-list > .v-list > div > a {
  height: 55px;
}
.search-list > div:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.05);
}
.search-item > a {
  height: 55px;
}
.edit-dialog {
  overflow-y: visible;
}
</style>